import BaseStore from "@/modules/baseStore.js";
import BaseApi from "@/modules/baseApi.js";


const state = {
  A_users: [],
}


const api = BaseApi(state, "customer")

export default BaseStore.extend({
  state,
  api
})